import type {Pointer} from '@wix/document-services-types'
import {type IPresetsService, PresetsService} from './service'
import {PresetsRepository} from './repository'
import {PresetsManifestProcessor} from './processor'
import {PresetsStylesTransformer} from './style-transformer'
import {PresetsDataTransformer} from './data-transformer'
import type {VariantsExtensionAPI} from '../../variants/variants'
import type {CreateExtArgs} from '@wix/document-manager-core'

export class PresetsServiceFactory {
    static createPresetsService(createExtArg: CreateExtArgs, rootWidget: Pointer): IPresetsService {
        const {variants: variantsAPI} = createExtArg.extensionAPI as VariantsExtensionAPI
        const presetsRepository = new PresetsRepository(variantsAPI, rootWidget)
        const presetsStyleTransformer = new PresetsStylesTransformer()
        const presetsManifestProcessor = new PresetsManifestProcessor(createExtArg, presetsStyleTransformer)
        const presetsDataTransformer = new PresetsDataTransformer()

        return new PresetsService(presetsRepository, presetsManifestProcessor, presetsDataTransformer)
    }
}
